module.exports = __webpack_public_path__ + "5.0.2/img/logo_5.3626ef9b.png";